<template>
    <div class="account">
        <div class="bc-index " @click="official_website">
            <!--      <router-link :to="{path:'/account/login'}">-->
            返回官网
            <li class="el-icon-my-home"></li>
            <!--      </router-link>-->
        </div>
        <div class="box">
            <div class="top_logo">
                <img src="@/assets/img/logo_wt.png" alt/>
            </div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    export default {
        name: "account",
        data() {
            return {};
        },
        created() {
        },
        methods: {
            official_website() {
                var pagename_one = window.location.host
                if (pagename_one.indexOf("aiosign.com") >= 0) {
                    this.new_url = 'https://' + pagename_one
                } else {
                    this.new_url = this.$SIF.get_url
                }
                window.location.href = this.new_url + '/index.html'
            },
        }
    };
</script>

<style scoped lang="scss">
    .account {
        height: 100%;
        width: 100%;
        background-image: url(~@/assets/img/account/login_bg.png);
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: center;
        align-items: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }

    .bc-index {
        position: absolute;
        left: 53px;
        top: 27px;
        color: #bfbfbf;
        cursor: pointer;
        height: 21px;
        font-size: 16px;
    }

    .bc-index .el-icon-my-home {
        width: 16px;
        height: 16px;
        display: inline-block;
        vertical-align: baseline;
        line-height: 21px;
        line-height /**/
        : 17px;
        line-height: 17px \9
    ;
        *line-height: 17px;

    }

    .box {
        display: inline-block;
        text-align: center;
    }
</style>
<style>

    .input {
        width: 281px;
        display: block;
        margin: 0 auto;
    }

    .input {
        margin-top: 22px;
        background-position: 18px center;
        background-repeat: no-repeat;
        display: block;
    }

    .input .el-input__inner {
        height: 47px;
        line-height: 47px;
        background: none;
        border-radius: 24px;
        border: 1px solid rgba(255, 255, 255, .38);

        padding-left: 49px;
        color: #fff;
        font-size: 14px;
    }

    .input .el-input__icon {
        line-height: 47px;
        width: 44px;
        font-size: 18px;
    }

    .account-butn {
        width: 282px;
        height: 47px;
        background: rgba(25, 188, 115, 1);
        border-radius: 24px;
        line-height: 47px;
        color: #fff;
        font-size: 16px;
        margin-top: 22px;
        cursor: pointer;
        border: none;
        padding: 0;
    }

    input:-webkit-autofill, textarea:-webkit-autofill, select:-webkit-autofill {
        -webkit-text-fill-color: #ededed !important;
        -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
        background-color: transparent;
        background-image: none;
        transition: background-color 50000s ease-in-out 0s;
    }

    input {
        background: none;
    }

    .userAccount-phone {
        background-image: url(~@/assets/img/account/icon_phone.png);
    }

    /* .userAccount-email {
      background-image: url(~@/assets/img/account/icon_email.png);
    } */
    .userPassword {
        background-image: url(~@/assets/img/account/icon_passcode.png);
    }

    .userAccount {
        background-image: url(~@/assets/img/account/icon_user.png);
    }

    .userPassword {
        background-image: url(~@/assets/img/account/icon_passcode.png);
    }

    .verifyCode {
        display: flex;
        width: 281px;
        margin: 0 auto;
        margin-top: 14px;
        justify-content: space-between;
        font-size: 14px;
        align-items: center;

    }

    .verifyCode .input {
        width: 166px;
        margin: 0;
    }

    .verifyCode .butn {
        width: 99px;
        height: 32px;
        border-radius: 5px;
        color: #fff;
        border: 1px solid rgba(255, 255, 255, 0.35);
        line-height: 32px;
        cursor: pointer;
        padding: 0;
        background: none;
    }

    .verifyCode .butn.on {
        background: rgba(255, 255, 255, 0.35);
    }

    .old_password {
        background-image: url(~@/assets/img/account/ico_oldcode.png);
    }

    .new_password {
        background-image: url(~@/assets/img/account/icon_passcode.png);
    }

    .affirm_password {
        margin-top: 13px;
        background-image: url(~@/assets/img/account/ico_confirmcode.png);
    }

    .affirm_password.affirm {
        background: url(~@/assets/img/account/ico_confirmcode_confirm.png) no-repeat 247px center,
        url(~@/assets/img/account/ico_confirmcode.png) no-repeat 18px center;
    }

    .passwor_dsafety {
        margin-top: 10px;
        font-size: 0;
    }

    .passwor_dsafety > div {
        width: 56px;
        line-height: 16px;
        display: inline-block;
        margin: 0 9px;
        font-size: 12px;
        color: #fff;
        background-color: rgba(105, 87, 87, 0.35);
    }

    .passwor_dsafety > div:first-child.on {
        background-color: #f2455b;
    }

    .passwor_dsafety > div:nth-child(2).on {
        background-color: #ec7042;
    }

    .passwor_dsafety > div:last-child.on {
        background-color: #02d373;
    }
</style>

